module.exports = {"createText":"添加角色","pageTitleText":"角色管理","roleName":"角色名称","status":"状态","action":"操作","downloadSystemCerts":"下载系统凭证"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/rolesmanage.json
// module id = ZKXF
// module chunks = 3